import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('okiescape-lang') || 'en');
  const [translations, setTranslations] = useState({});
  const [loaded, setLoaded] = useState(false);

  const fetchContent = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/api/content`);
      const map = {};
      data.forEach(item => { map[item.key] = item; });
      setTranslations(map);
      setLoaded(true);
    } catch {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { fetchContent(); }, [fetchContent]);

  const toggleLang = () => {
    setLang(prev => {
      const next = prev === 'en' ? 'ja' : 'en';
      localStorage.setItem('okiescape-lang', next);
      return next;
    });
  };

  const t = (key) => {
    if (translations[key]) return translations[key][lang] || translations[key].en || key;
    return key;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t, translations, fetchContent, loaded }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
